import { filterMode } from '@dmp/feedr/models';
import { zodNumberLike } from '@dmp/shared/zod-utils';
import { z } from 'zod';

export const feedsConsumeQueryValidator = z.object({
    filterMode: filterMode().default('all'),
    filter: z.record(z.string(), z.any()).optional(),
    limit: zodNumberLike()
        .pipe(z.number().int().max(500).positive())
        .optional(),
});

export type FeedsConsumeQuery = z.output<typeof feedsConsumeQueryValidator>;
